import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, createTheme, ThemeProvider } from "@mui/material";
import Widget from "./components/Widget";
import { getWhatsappWidgetInfo } from './services/restAPIServices';

function App() {
    const theme = createTheme({
      typography: {
        fontFamily: "DM Sans Regular",
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 400,
          md: 900,
          lg: 1200,
          xl: 1425,
        },
      },
    });

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const widgetId = params.get('widgetId');
    const bgColor = params.get('bgc');
    const [loading, setLoading] = useState(true)    
    const [widgetInfo,setWidgetInfo]=useState(null)
    const defaultWidgetInfo= {
      agentsEnabled:false,
      agents:[],
      widgetConfig:{ 
        color: '#FFFFFF',
        background: '#085E56',
        heading: "Let's connect on Whatsapp",
        greeting: 'How Can I Help You Today ?',
        logo: 'default',
        location: 'right',
        redirectNumber:'',
      }
    };


    const fetchWidgetInfo=async()=>{
      try{
          const response =await getWhatsappWidgetInfo(widgetId)
          if(response.status===200){
            const data=response.data
            setWidgetInfo(data);
            setLoading(false)
          }
    
        }
        catch(error){
          console.log("Error getting Bot Info",error)
        }
      }
    useEffect(() => {
      if(widgetId!==null){
        fetchWidgetInfo();
      }
    },[]);

  return (
     <ThemeProvider theme={theme}>
     {loading ? (
       <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',background: '#FFFFFF', borderRadius: "15px 15px 15px 15px"}}>
         <CircularProgress variant="indeterminate" size={50} sx={{color:bgColor??'#085E56'}} />
       </Box>
     ) : (
       <Widget widgetInfo={widgetInfo ?? defaultWidgetInfo}/>
     )}
   </ThemeProvider>
  );
}

export default App;
